<template>
  <div id="stripe-container" ref="scriptContainer"></div>
</template>

<script>
  export default {
    props: [
      'stripeKey',
      'label',
      'amount',
      'title'
    ],

    mounted () {
      const script = document.createElement('script')

      script.setAttribute('src', 'https://checkout.stripe.com/checkout.js')
      script.classList = 'stripe-button'
      script.dataset.key = this.stripeKey
      // script.dataset.image = 'https://stripe.com/img/documentation/checkout/marketplace.png'
      script.dataset.name = this.title
      script.dataset.description = ''
      script.dataset.amount = this.amount
      script.dataset.label = this.label
      script.dataset.currency = 'JPY'
      script.dataset.locale = 'auto'

      this.$refs.scriptContainer.appendChild(script)
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  #stripe-container {
    display: flex;
    align-items: center;
    .stripe-button-el {
      background: none;
      border: none;
      box-shadow: none;
      padding: 0;
      span {
        display: inline-block;
        background: #2196f3;
        color: #fff !important;
        width: 100%;
        height: 100%;
        padding: 8px 16px;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
        &:hover {
          opacity: .9;
        }
      }
    }
  }
</style>
